import { z } from 'zod'

const accessTokenSchema = z.object({
  exp: z.coerce.number(),
  realm_access: z.object({
    roles: z.array(z.string()),
  }),
  resource_access: z
    .object({
      'realm-management': z
        .object({
          roles: z.array(z.string()),
        })
        .optional(),
    })
    .optional(),
  site: z.string(),
  preferred_username: z.string(),
})

type AccessTokenData = z.infer<typeof accessTokenSchema>

export { accessTokenSchema, type AccessTokenData }
